import { Component, ViewEncapsulation } from '@angular/core';
import { IconMapper } from '../../helpers/icon-mapper';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-button',
    templateUrl: './button.html',
    styleUrls: ['../../../styles/styles.scss', './button.scss'],
    encapsulation: ViewEncapsulation.None
})
// tslint:disable-next-line:component-class-suffix
export class CfaButton extends IconMapper {
    icon = 'Menu';

    constructor() {
        super();
    }

}
